
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M3.51468 9.17155L1.74696 7.40374L7.40381 1.74689L11.1161 5.4592L12.0297 6.37275M3.51468 9.17155L5.63595 7.05028M3.51468 9.17155L5.28249 10.9393M6.37282 12.0296L5.28249 10.9393M12.3535 18.0104L13.0606 18.7175M14.8285 20.4852L16.5962 22.253L22.2531 16.5961L17.6397 11.9828M14.8285 20.4852L16.9498 18.3639M14.8285 20.4852L13.0606 18.7175M5.28249 10.9393L7.40381 8.81795M13.0606 18.7175L15.182 16.5961"></path><path d="M13.7678 4.57537L2.57538 15.7678V21.4246L8.23223 21.4246L19.4246 10.2322M13.7678 4.57537L16.5962 1.74695L22.253 7.4038L19.4246 10.2322M13.7678 4.57537L19.4246 10.2322"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiDesigner",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
